import { Controller } from "@hotwired/stimulus";

/**
 * Filters the member list in the GroupMemberSelectorComponent by name.
 * Targets: search (input), item (list items with data-name attribute)
 */
export default class extends Controller {
  static targets = ["search", "item"];

  filter() {
    const query = this.searchTarget.value.toLowerCase().trim();

    this.itemTargets.forEach((item) => {
      const name = (item.dataset.name || "").toLowerCase().trim();
      item.style.display = name.includes(query) ? "" : "none";
    });
  }
}
